







import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import ChangeLanguage from '@/mixins/ChangeLanguage';
import LocationPanelItemHeader from '@/components/location/location-panel/location-panel-item/LocationPanelItemHeader.vue';
import { namespace } from 'vuex-class';

const Markers = namespace('markers');

@Component({
    components: { LocationPanelItemHeader },
})
export default class LocationPanelMarkerItem extends mixins(ChangeLanguage) {
    @Prop({ type: String, required: true })
    id!: string;

    @Prop({ type: String, required: true })
    title!: string;

    @Prop({ type: String, required: false, default: null })
    subtitle!: string | null;

    @Prop({ type: String, required: true })
    image!: string;

    @Markers.Mutation
    setActiveMarkerId!: (id: string | null) => void;

    private openMarkerDetails(): void {
        this.setActiveMarkerId(this.id);
        this.navigateToLocation();
    }

    private navigateToLocation(): void {
        const locationId = this.$route.params.location;
        this.$router.push({
            name: 'marker',
            params: {
                locale: this.currentLanguage.code,
                location: locationId,
                marker: this.id,
            },
        });
    }
}
